(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-carousel-inner"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const addToCartButtons = document.querySelectorAll('.flavor-carousel-product-card-add-btn');

  // Toggle dropdown logic
  document.querySelectorAll('.custom-variant-trigger').forEach(trigger => {
    const dropdownId = trigger.getAttribute('data-dropdown-id');
    const dropdown = document.getElementById(dropdownId);
    const selectedText = trigger.querySelector('.selected-variant');

    if (!dropdown || !selectedText) return;

    // Step 1 prerequisite: allow programmatic focus on options
    dropdown.querySelectorAll('.variant-option').forEach(opt => {
      if (!opt.hasAttribute('tabindex')) opt.setAttribute('tabindex', '-1');
    });

    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();   // prevent page scroll on Space + prevent any default "button-like" behavior
        e.stopPropagation();  // keep it consistent with click
        trigger.click();      // re-use existing click handler
      }
    });
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();

      // Hide any other open dropdowns
      document.querySelectorAll('.variant-options-container').forEach(d => {
        if (d !== dropdown) {
          d.style.display = 'none';
        }
      });

      // Show this dropdown
      const isOpening = dropdown.style.display !== 'block';
      dropdown.style.display = isOpening ? 'block' : 'none';

      if (isOpening) {
        const options = Array.from(dropdown.querySelectorAll('.variant-option'));
        const selectedLabel = (selectedText.textContent || '').trim();

        const targetOption =
          options.find(o => (o.textContent || '').trim() === selectedLabel) || options[0];

        if (targetOption) {
          requestAnimationFrame(() => {
            try { targetOption.focus(); } catch (e) {}
          });
        }
      }
    });

    // Variant selection inside dropdown
    dropdown.querySelectorAll('.variant-option').forEach(option => {
      option.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          option.click();
          return;
        }
        // Escape + Tab routing
        if (e.key === 'Escape') {
          e.preventDefault();
          e.stopPropagation();

          const container = option.closest('.variant-options-container');
          if (container) container.style.display = 'none';

          // return focus to the trigger for this dropdown
          const trigger = document.querySelector(`.custom-variant-trigger[data-dropdown-id="${container ? container.id : ''}"]`);
          if (trigger) trigger.focus();
          return;
        }

        if (e.key === 'Tab') {
          e.preventDefault();
          e.stopPropagation();

          const container = option.closest('.variant-options-container');
          if (container) container.style.display = 'none';

          const trigger = container
            ? document.querySelector(`.custom-variant-trigger[data-dropdown-id="${container.id}"]`)
            : null;

          const cardRoot = trigger ? trigger.closest('.cell-container') : null;
          const addBtn = cardRoot ? cardRoot.querySelector('.flavor-carousel-product-card-add-btn') : null;

          if (e.shiftKey) {
            requestAnimationFrame(() => {
              if (trigger) trigger.focus({ preventScroll: true });
            });
          } else {
            requestAnimationFrame(() => {
              if (addBtn) addBtn.focus({ preventScroll: true });
            });
          }
          return;
        }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          e.stopPropagation();

          const container = option.closest('.variant-options-container');
          if (!container) return;

          const options = Array.from(container.querySelectorAll('.variant-option'));
          const currentIndex = options.indexOf(option);
          if (currentIndex === -1) return;

          const nextIndex =
            e.key === 'ArrowDown'
              ? Math.min(options.length - 1, currentIndex + 1)
              : Math.max(0, currentIndex - 1);

          const nextOption = options[nextIndex];
          if (nextOption) nextOption.focus();
        }
      });
      option.addEventListener('click', () => {
        const variantId = option.dataset.id;
        const variantPrice = option.dataset.price;
        const title = option.textContent;

        selectedText.textContent = title;
        dropdown.style.display = 'none';

        const productCard = trigger.closest('.flavor-carousel-product-card');
        const addBtn = productCard.querySelector('.flavor-carousel-product-card-add-btn');
        const priceEl = productCard.querySelector('.flavor-carousel-variant-price');

        if (addBtn) addBtn.setAttribute('data-product-id', variantId);
        if (priceEl){priceEl.textContent = formatMoney(variantPrice); priceEl.setAttribute('data-product-id', variantId); } 
        requestAnimationFrame(() => {
          addBtn && addBtn.focus({ preventScroll: true });
        });
      });
    });
  });

  // Close dropdown if clicked outside
  document.addEventListener('click', () => {
    document.querySelectorAll('.variant-options-container').forEach(dropdown => {
      dropdown.style.display = 'none';
    });
  });

  // Add to cart functionality
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const variantId = this.getAttribute('data-product-id');
      const quantity = 1;

      addToCart(variantId, quantity);
    });
  });

  function addToCart(variantId, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
  }

  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["find-your-flavor-snippet"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const addToCartButtons = document.querySelectorAll('.flavor-carousel-product-card-add-btn');

  // Toggle dropdown logic
  document.querySelectorAll('.custom-variant-trigger').forEach(trigger => {
    const dropdownId = trigger.getAttribute('data-dropdown-id');
    const dropdown = document.getElementById(dropdownId);
    const selectedText = trigger.querySelector('.selected-variant');

    if (!dropdown || !selectedText) return;

    // Step 1 prerequisite: allow programmatic focus on options
    dropdown.querySelectorAll('.variant-option').forEach(opt => {
      if (!opt.hasAttribute('tabindex')) opt.setAttribute('tabindex', '-1');
    });

    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();   // prevent page scroll on Space + prevent any default "button-like" behavior
        e.stopPropagation();  // keep it consistent with click
        trigger.click();      // re-use existing click handler
      }
    });
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();

      // Hide any other open dropdowns
      document.querySelectorAll('.variant-options-container').forEach(d => {
        if (d !== dropdown) {
          d.style.display = 'none';
        }
      });

      // Show this dropdown
      const isOpening = dropdown.style.display !== 'block';
      dropdown.style.display = isOpening ? 'block' : 'none';

      if (isOpening) {
        const options = Array.from(dropdown.querySelectorAll('.variant-option'));
        const selectedLabel = (selectedText.textContent || '').trim();

        const targetOption =
          options.find(o => (o.textContent || '').trim() === selectedLabel) || options[0];

        if (targetOption) {
          requestAnimationFrame(() => {
            try { targetOption.focus(); } catch (e) {}
          });
        }
      }
    });

    // Variant selection inside dropdown
    dropdown.querySelectorAll('.variant-option').forEach(option => {
      option.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          option.click();
          return;
        }
        // Escape + Tab routing
        if (e.key === 'Escape') {
          e.preventDefault();
          e.stopPropagation();

          const container = option.closest('.variant-options-container');
          if (container) container.style.display = 'none';

          // return focus to the trigger for this dropdown
          const trigger = document.querySelector(`.custom-variant-trigger[data-dropdown-id="${container ? container.id : ''}"]`);
          if (trigger) trigger.focus();
          return;
        }

        if (e.key === 'Tab') {
          e.preventDefault();
          e.stopPropagation();

          const container = option.closest('.variant-options-container');
          if (container) container.style.display = 'none';

          const trigger = container
            ? document.querySelector(`.custom-variant-trigger[data-dropdown-id="${container.id}"]`)
            : null;

          const cardRoot = trigger ? trigger.closest('.cell-container') : null;
          const addBtn = cardRoot ? cardRoot.querySelector('.flavor-carousel-product-card-add-btn') : null;

          if (e.shiftKey) {
            requestAnimationFrame(() => {
              if (trigger) trigger.focus({ preventScroll: true });
            });
          } else {
            requestAnimationFrame(() => {
              if (addBtn) addBtn.focus({ preventScroll: true });
            });
          }
          return;
        }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          e.stopPropagation();

          const container = option.closest('.variant-options-container');
          if (!container) return;

          const options = Array.from(container.querySelectorAll('.variant-option'));
          const currentIndex = options.indexOf(option);
          if (currentIndex === -1) return;

          const nextIndex =
            e.key === 'ArrowDown'
              ? Math.min(options.length - 1, currentIndex + 1)
              : Math.max(0, currentIndex - 1);

          const nextOption = options[nextIndex];
          if (nextOption) nextOption.focus();
        }
      });
      option.addEventListener('click', () => {
        const variantId = option.dataset.id;
        const variantPrice = option.dataset.price;
        const title = option.textContent;

        selectedText.textContent = title;
        dropdown.style.display = 'none';

        const productCard = trigger.closest('.flavor-carousel-product-card');
        const addBtn = productCard.querySelector('.flavor-carousel-product-card-add-btn');
        const priceEl = productCard.querySelector('.flavor-carousel-variant-price');

        if (addBtn) addBtn.setAttribute('data-product-id', variantId);
        if (priceEl){priceEl.textContent = formatMoney(variantPrice); priceEl.setAttribute('data-product-id', variantId); } 
        requestAnimationFrame(() => {
          addBtn && addBtn.focus({ preventScroll: true });
        });
      });
    });
  });

  // Close dropdown if clicked outside
  document.addEventListener('click', () => {
    document.querySelectorAll('.variant-options-container').forEach(dropdown => {
      dropdown.style.display = 'none';
    });
  });

  // Add to cart functionality
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const variantId = this.getAttribute('data-product-id');
      const quantity = 1;

      addToCart(variantId, quantity);
    });
  });

  function addToCart(variantId, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
  }

  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }
});
  } catch(e) { console.error(e); }
})();

})();
